      import React from 'react';
      import './Footer.css';
      import Bhugol from "../Images/Bhugol.png";
      import { FaFacebookF, FaYoutube, FaLinkedinIn, FaInstagram, FaTwitter, FaEnvelope, FaPhoneAlt, FaMapMarkerAlt } from "react-icons/fa";

      const Footer = () => {
        return (
          <footer className="footer">
            {/* <div style={{ backgroundColor: "#0c2d62", color: "white", padding: "15px 10px", display: "flex", justifyContent: "space-between", alignItems: "left" }}>
              <h3 style={{ margin: 0 }}>Get connected with us on social networks.</h3>
              <div style={{ display: "flex", gap: "20px" }}>
              <a href="https://www.facebook.com/mahapreit" target="_blank" rel="noopener noreferrer" >
              <FaFacebookF size={20} 
              style={{
                  fontSize: "20px",
                  margin: "0px 0px 0px 0px",
                  color: "#fff",
                }}
              />
            </a>
            <a href="https://www.youtube.com/channel/UC6mkep2n14fiMXZkCWKynEA" target="_blank" rel="noopener noreferrer">
              <FaYoutube size={20} 
              style={{
                  fontSize: "20px",
                  margin: "0px 0px 0px 0px",
                  color: "#fff",
                }}
              />
            </a>
            <a href="https://www.linkedin.com/company/mahapreit" target="_blank" rel="noopener noreferrer">
              <FaLinkedinIn size={20}style={{
                      fontSize: "20px",
                      margin: "0px 0px 0px 0px",
                      color: "#fff",
                    }}
                    />
            </a>
            <a href="https://www.instagram.com/mahapreit/" target="_blank" rel="noopener noreferrer">
              <FaInstagram size={20} 
              style={{
                  fontSize: "20px",
                  margin: "0px 0px 0px 0px",
                  color: "#fff",
                }}
                />
            </a>
            <a href="https://twitter.com/mahapreit" target="_blank" rel="noopener noreferrer">
              <FaTwitter size={20} 
              style={{
                      fontSize: "20px",
                      margin: "0px 0px 0px 0px",
                      color: "#fff",
                    }}
                    />
            </a>
              </div>
            </div> */}
            <div className="footer-columns">
              {/* Column 1 */}
              <div className="footer-col">
                <h4>HINDU KHATIK SAMAJ ECONOMIC DEVELOPMENT CORPORATION</h4>
                <p>
                Hindu Khatik Samaj Economic Development Corporation is committed to empowering the Hindu Khatik community through financial support, skill development, and self-employment initiatives.</p>
              </div>

              {/* Column 2 */}
              <div className="footer-col">
                <h4>USEFUL LINKS</h4>
                <ul>
                  <li><a href="https://mahapreit.in/">MahaPREIT</a></li>
                  <li><a href="https://mpbcdc.maharashtra.gov.in/">MPBCDC</a></li>
                  <li><a href="https://www.digilocker.gov.in/">DigiLocker</a></li>
                  <li><a href="https://uidai.gov.in/">UIDAI</a></li>
                  <li><a href="https://sjsa.maharashtra.gov.in/">Social Justice</a></li>
                  <li><a href="https://rdd.maharashtra.gov.in/">Rural RDD</a></li>
                </ul>
              </div>

            

              {/* Column 4 */}
              <div className="footer-col">
                <h4>MPBCDC (Head Office)</h4>
                <p><FaMapMarkerAlt className="icon" /> Shop No.25/2, Juhu Supreme Shopping Centre Gulmohar, Cross Rd Number 9, JVPD Scheme, Juhu, Mumbai, Maharashtra 400049</p>
                <p><FaEnvelope className="icon" /> info[at]mpbcdc[dot]in</p>
                <p><FaPhoneAlt className="icon" /> (022) 26200351 / (022) 26202852</p>
              </div>

            
            </div>

          
          </footer>
        );
      };

      export default Footer;